import { APIError, APIParameters, APIResult } from "common";
import { useCallback, useState } from "react";
import { APICall } from "./api";

export type APIQueryState = "loading" | "error" | "success" | "idle";

export const useAPIQuery = <T extends keyof APIParameters>({
  apiCall,
}: {
  apiCall: APICall<T>;
}) => {
  const [data, setData] = useState<APIResult[T] | undefined>(undefined);
  const [state, setState] = useState<APIQueryState>("idle");
  const [error, setError] = useState<APIError | undefined>(undefined);
  const query = useCallback(
    async (params: APIParameters[T]) => {
      try {
        setState("loading");
        const result = await apiCall(params);
        setData(result);
        setState("success");
      } catch (e) {
        if (e instanceof APIError) {
          setError(e);
          setState("error");
          return;
        }
        throw e;
      }
    },
    [apiCall]
  );

  const clearData = useCallback(() => {
    setData(undefined);
  }, []);

  return {
    query,
    data,
    state,
    error,
    clearData,
  };
};
